<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-05-24 10:51:35
 * @LastEditTime: 2026-07-02 16:07:41
 * @LastEditors: hexy 913752270@qq.com
 * @Description  : 标号信息价弹窗
 * @FilePath     : \icps_fb\src\views\platform\ICPS\Wise\Wise_contactsbusiness\monthlyReportDialog\priceMaintenanceDialog.vue
-->
<template>
  <el-dialog v-dialogDrag :visible.sync="priceMaintenanceDialog" width="1300px" :append-to-body="true" :close-on-click-modal="false" :before-close="close" @open="openMethod">
    <span slot="title" class="dialog-title">标号信息价</span>
    <div class="dialoginfo table">
      <div class="search">
        <span style="display: inline-block; margin-bottom: 10px">
          <span style="margin-right: 12px">城市：</span>
          <el-select v-model="tableParam.cityDode" placeholder="请选择" style="width: 150px" clearable>
            <el-option v-for="item in cityList" :key="item.cityDode" :label="item.cityName" :value="item.cityDode"> </el-option>
          </el-select>
        </span>
        <span style="margin-left: 24px">
          <span style="margin-right: 12px">类型：</span>
          <el-select v-model="tableParam.informationPriceType" placeholder="请选择" style="width: 150px" clearable>
            <el-option v-for="item in priceTypelist" :key="item.id" :label="item.value" :value="item.id"> </el-option>
          </el-select>
        </span>
        <span style="margin-left: 24px">
          <span style="margin-right: 12px">信息价期数：</span>
          <el-input v-model="tableParam.dataPeriods" oninput="value=value.replace(/[^\d]/g,'');if(value<0)value=0;if(value>12)value=12" style="width: 150px" clearable placeholder="请输入" />
        </span>
        <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="(tableParam.page = 1), gettableData()">查 询</el-button>
      </div>
    </div>
    <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark">
      <template v-for="(item, index2) in table">
        <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :min-width="item.width" :fixed="item.label == '操作' ? 'right' : false">
          <template slot-scope="scope">
            <span v-if="item.label == '信息价期数'"> {{ scope.row.dataYear }}年 第{{ scope.row.dataPeriods }}期 </span>
            <span v-else-if="item.label == '状态'">
              <span v-if="scope.row.enable == 0" style="color: #969799">禁用</span>
              <span v-if="scope.row.enable == 1" style="color: #00a754">启用</span>
            </span>
            <div v-else-if="item.label == '操作'">
              <el-button class="bottom_one" size="mini" @click="update(scope.row)">查看</el-button>
            </div>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <div class="card_bottom">
      <div class="card_bottom_left">
        <div class="top_page_totle">总共{{ total }}条</div>
        <el-pagination
          :current-page.sync="tableParam.page"
          :page-size="tableParam.pageSize"
          :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
          layout="prev,pager,sizes,next,jumper"
          :total="total"
          @size-change="sizeChange"
          @current-change="gettableData()"
        ></el-pagination>
      </div>
      <div>
        <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="close()">关 闭</el-button>
    </span>
    <!-- 查看 -->
    <el-dialog v-dialogDrag :visible.sync="addDialog" width="1180px" :close-on-click-modal="false" append-to-body>
      <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
      <div>
        <div class="top">
          <el-row>
            <el-col :span="12">
              <div>
                <span style="font-size:18px">期数：{{ fromDate.dataYear }}年 第{{ fromDate.dataPeriods }}期</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="top">
                <span style="font-size:18px">生效时间：{{ fromDate.startTime + "-" + fromDate.endTime }}</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div style="padding-top: 20px">
          <span>以下价格为不含税价格</span>
        </div>
        <div style="padding-top: 15px">
          <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="lineList" tooltip-effect="dark" height="520px">
            <template v-for="(item, index2) in columnList">
              <el-table-column v-if="index2 == 0" :key="index2" width="120px" :label="item.itemName" align="center">
                <template slot="header">
                  <div class="xieXian">
                    <div></div>
                    <span>区域</span>
                    <span>标号</span>
                  </div>
                </template>
                <template slot-scope="scope">
                  {{ scope.row.itemCode }}
                </template>
              </el-table-column>
              <el-table-column v-else-if="item.type === 1 || item.type === 2 || item.type === 3" :key="index2" :label="item.itemName" :prop="item.itemName" align="center" width="160px"> </el-table-column>
            </template>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetFromDate">取 消</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryPage, queryDetail } from "@/api/basicConfig/priceMaintenance.js";
export default {
  mixins: [mixin],
  components: {},
  props: {
    priceMaintenanceDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      queryPage: queryPage,
      priceData: [],
      priceData2: [],
      files: [],
      areaList: "",
      /*表格数据*/
      table: [
        { label: "信息价期数", width: "auto", prop: "dataPeriods", status: true },
        { label: "信息价登记人", width: "120", prop: "createUserName", status: true },
        { label: "生效日期", width: "120", prop: "startTime", status: true },
        { label: "操作", width: "120", prop: "", status: true },
      ],
      cityList: [
        {
          cityName: "重庆",
          cityDode: "chongqing",
          buttonCode: "CHONGQING",
          status: false,
        },
        {
          cityName: "成都",
          cityDode: "chendu",
          buttonCode: "CHENGDU",
          status: false,
        },
        {
          cityName: "绵竹",
          cityDode: "mianzhu",
          buttonCode: "MIANZHU",
          status: false,
        },
        {
          cityName: "遂宁",
          cityDode: "suining",
          buttonCode: "SUINING",
          status: false,
        },
        {
          cityName: "资阳",
          cityDode: "ziyang",
          buttonCode: "ZIYANG",
          status: false,
        },
        {
          cityName: "德阳",
          cityDode: "deyang",
          buttonCode: "DEYANG",
          status: false,
        },
        {
          cityName: "眉山",
          cityDode: "meishan",
          buttonCode: "MEISHAN",
          status: false,
        },
        {
          cityName: "宜宾",
          cityDode: "yibin",
          buttonCode: "YIBIN",
          status: false,
        },
        {
          cityName: "内江",
          cityDode: "neijiang",
          buttonCode: "NEIJIANG",
          status: false,
        },
        {
          cityName: "西昌",
          cityDode: "xichang",
          buttonCode: "XICHANG",
          status: false,
        },
        {
          cityName: "绵阳",
          cityDode: "mianyang",
          buttonCode: "MIANYANG",
          status: false,
        },
        {
          cityName: "广安",
          cityDode: "guangan",
          buttonCode: "GUANGAN",
          status: false,
        },
        {
          cityName: "达州",
          cityDode: "dazhou",
          buttonCode: "DAZHOU",
          status: false,
        },
        {
          cityName: "南充",
          cityDode: "nanchong",
          buttonCode: "NANCHONG",
          status: false,
        },
        {
          cityName: "乐山",
          cityDode: "leshan",
          buttonCode: "LESHAN",
          status: false,
        },
      ],
      priceTypelist: [
        {
          value: "混凝土信息价",
          id: 1,
        },
        {
          value: "湿拌砂浆信息价",
          id: 2,
        },
        {
          value: "干混砂浆信息价",
          id: 3,
        },
      ],
      fromDate: {},
      columnList: [],
      lineList: [],
    };
  },
  created() {
    this.tableParam = { ...this.tableParam, dataPeriods: "", createUserName: "", informationPriceType: 1, cityDode: "chendu" };
  },
  methods: {
    /**查看*/
    update(low) {
      this.addDialog = true;
      queryDetail({ id: low.id }).then(res => {
        if (res.code === 1001) {
          this.fromDate = {
            id: res.data.id,
            dataYear: res.data.dataYear,
            dataPeriods: res.data.dataPeriods,
            startTime: res.data.startTime,
            endTime: res.data.endTime,
          };
          const columnList = [
            {
              itemName: "itemCode",
              type: 1,
              itemCode: "itemCode",
            },
          ];
          const lineList = [];
          /**
           * @Description: 构造表头
           * @param {*} let
           * @Author: wangwangwang
           */
          for (let i = 0; i < res.data.tableLable.length; i += 1) {
            const data = {
              itemName: res.data.tableLable[i].itemName,
              itemCode: res.data.tableLable[i].itemCode,
              gradeId: res.data.tableLable[i].gradeId,
              type: res.data.tableLable[i].type * 1,
            };
            columnList.push(data);
          }
          this.columnList = columnList;
          /**
           * @Description: 构造数据
           * @param {*}
           * @Author: wangwangwang
           */
          res.data.tableArea.forEach(item => {
            const data = {
              areaCode: item.itemCode,
              itemCode: item.itemName,
            };
            res.data.tableLable.forEach(item2 => {
              let cell = res.data.valueList.find(res => res.lableId == item2.id && res.areaCode == item.id);
              data[item2.itemName] = cell?.dataValue || "";
              data.lableId = cell?.lableId || "";
            });
            lineList.push(data);
          });
          this.lineList = lineList;
          console.log(JSON.parse(JSON.stringify(this.lineList)));
        }
      });
    },
    openMethod() {
      this.gettableData();
    },
    close() {
      this.$emit("closePriceMaintenanceDialog", false);
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.popperClass.el-date-picker {
  width: 220px;
}
.card_bottom {
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 72px;

  .card_bottom_left {
    display: flex;
    align-items: center;
    font-size: $font_size;
  }
}
</style>